
  import Vue from 'vue'
  import IoTDeviceMappingService from '@/services/IoTDeviceMappingService';

  import { extractErrorMessage } from '@/utils/Util';

  export default Vue.extend({
    name: 'IotDeviceMappingDeleteDialog',

    props: ['iotdevice', 'iotdeviceport', 'iotdevicemapping'],
    data: () => ({
        localDialog: false,
        alertText: "",
        alertVisible: false,
        alertType: "error",
        loading: false,
    }),
    methods: {
      close() {
        this.localDialog = false;
      },
      clear() {
        this.alertVisible = false;
        this.loading = false;
      },
      dismiss() {
        this.clear();
        this.close();
      },
      confirmDelete() {
        this.loading = true;
      
        IoTDeviceMappingService.delete(this.iotdevice.uuid, this.iotdeviceport.uuid, this.iotdevicemapping.uuid).then(() => {
            this.alertType = "success";
            this.alertText = this.$t('iotdevicemapping.successDelete') as string;
            this.alertVisible = true;
            this.loading = false;

            this.$emit("delete", this.iotdevicemapping);

            setTimeout(() => { 
                this.dismiss(); 
            }, 1500);
        }).catch((err) => {
            console.log(err);
            console.log(err.response);
            this.alertType = "error";
            this.alertText = this.$t('iotdevicemapping.errorDelete') + ' ' + extractErrorMessage(err);
            this.alertVisible = true; 
            this.loading = false;
        });
      }
    }
  })
